import { cn } from "@/lib/utils";

interface VeeraThinkingStateProps {
  phrase: string;
  className?: string;
}

export function VeeraThinkingState({ phrase, className }: VeeraThinkingStateProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <p className="text-sm text-muted-foreground">{phrase}</p>
      <div className="flex items-center gap-1 text-muted-foreground" aria-label="thinking">
        <span
          data-testid="veera-thinking-dot"
          aria-hidden="true"
          className="inline-block text-sm animate-bounce [animation-delay:-0.2s]"
        >
          .
        </span>
        <span
          data-testid="veera-thinking-dot"
          aria-hidden="true"
          className="inline-block text-sm animate-bounce [animation-delay:-0.1s]"
        >
          .
        </span>
        <span
          data-testid="veera-thinking-dot"
          aria-hidden="true"
          className="inline-block text-sm animate-bounce"
        >
          .
        </span>
      </div>
    </div>
  );
}
